import type { Youtube } from "@sorcery/cms";
import { YoutubePlayer } from "@sorcery/ui";

export const SanityVideo = ({ value }: { value: Youtube }) => {
  const { url } = value;
  if (!url) {
    return <div>Missing YouTube URL</div>;
  }

  return <YoutubePlayer url={url} />;
};
